import { Product, DistributorConfig } from '../types';
import giffarineProductsData from './giffarine_all_products.json';

export const DISTRIBUTOR_INFO: DistributorConfig = {
  distributorName: "",
  distributorCode: "108037654",
  phone: "",
  lineId: "@997wvsow",
  promptPayNumber: "",
  promptPayName: "GIFFFORYOU.COM",
  bankName: "ธนาคารกสิกรไทย (K-Bank)",
  bankAccount: "",
  codFee: 0,
  freeShippingThreshold: 500,
  shippingFee: 40,
};

export const CATEGORIES = [
  { id: 'all', name: 'สินค้าทั้งหมด', icon: 'Sparkles', color: 'bg-blue-50 text-blue-600' },
  { id: 'health', name: 'สุขภาพ & อาหารเสริม', icon: 'HeartPulse', color: 'bg-emerald-50 text-emerald-600' },
  { id: 'beauty', name: 'ดูแลผิวหน้า & ผิวกาย', icon: 'Smile', color: 'bg-rose-50 text-rose-600' },
  { id: 'cosmetics', name: 'เครื่องสำอาง', icon: 'Sparkle', color: 'bg-purple-50 text-purple-600' },
  { id: 'home', name: 'ของใช้ในบ้าน & ซักผ้า', icon: 'Home', color: 'bg-amber-50 text-amber-600' },
  { id: 'food', name: 'กาแฟ & เครื่องดื่มสุขภาพ', icon: 'Coffee', color: 'bg-orange-50 text-orange-600' },
  { id: 'agriculture', name: 'ปุ๋ย & นวัตกรรมเกษตร', icon: 'Sprout', color: 'bg-lime-50 text-lime-700' },
] as const;

export const PRODUCTS: Product[] = giffarineProductsData as unknown as Product[];
